import { decodeValues, getLayer, IField, IQueryFeaturesResponse, queryFeatures } from "@esri/arcgis-rest-feature-service";
import { Layer } from "../interfaces/layer";

export const GetQueryFeatures = async (layer: Layer, excludeFieldDecode: string[] = []): Promise<IQueryFeaturesResponse> =>  {
    const layerDef = await getLayer({ url: layer.url! });
    let response = await queryFeatures({
        url: layer.url!,
        where: layer.style2D?.query,
    }) as IQueryFeaturesResponse;
    response = await decodeValues({
        queryResponse: response!,
        fields: layerDef.fields?.filter(field=> !excludeFieldDecode.includes(field.name))
        });
    response.fields = layerDef.fields;
    return response
}

export const GetFields = async (layer: Layer): Promise<IField[] | undefined> =>  {
    const layerDef = await getLayer({ url: layer.url! });
    return layerDef.fields
}